import React, { useState } from "react";
import { Alert, Box, Button, Container, MenuItem, Paper, TextField, Typography } from "@mui/material";
import axios from "axios";
import { newUser } from "../BaseURL";

export default function CreateUserPage() {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    username: "",
    tel: "",
    password: "",
    role: "user",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      // The axios interceptor in App.js attaches x-user-id automatically.
      const res = await axios.post(newUser, form);
      if (!res.data?.success) {
        setError(res.data?.message || "Failed to create user");
        return;
      }
      setSuccess("User created successfully");
      setForm({ full_name: "", email: "", username: "", tel: "", password: "", role: "user" });
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create user");
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", py: 8, bgcolor: "#f8f5f0" }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: 4, borderRadius: 4, boxShadow: 4 }}>
          <Typography variant="h4" sx={{ mb: 1, color: "primary.main", fontWeight: 700 }}>
            Create User
          </Typography>
          <Typography sx={{ mb: 3, color: "text.secondary" }}>
            Only an admin can create management users.
          </Typography>
          {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}
          {success ? <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert> : null}
          <form onSubmit={handleSubmit}>
            <TextField label="Full Name" name="full_name" fullWidth margin="normal" value={form.full_name} onChange={handleChange} />
            <TextField label="Email" name="email" fullWidth margin="normal" value={form.email} onChange={handleChange} />
            <TextField label="Username" name="username" required fullWidth margin="normal" value={form.username} onChange={handleChange} helperText="Users log in with their username, not email." />
            <TextField label="Telephone" name="tel" fullWidth margin="normal" value={form.tel} onChange={handleChange} />
            <TextField label="Password" name="password" type="password" fullWidth margin="normal" value={form.password} onChange={handleChange} />
            <TextField select label="Role" name="role" fullWidth margin="normal" value={form.role} onChange={handleChange}>
              <MenuItem value="user">User</MenuItem>
            </TextField>
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, py: 1.3 }}>
              Create User
            </Button>
          </form>
        </Paper>
      </Container>
    </Box>
  );
}
